import type React from "react";

import { Box, styled } from "@mui/material";
import { useParams } from "react-router-dom";

import { useFeatureToggleContext } from "contexts/FeatureToggleContext";
import { useProfileContext } from "contexts/ProfileContext";
import { Feature } from "utils/features/types";
import { userIsPhysician } from "utils/profile/profileHelper";

import { PhysicianList } from "../PhysicianList";
import { RecordNoteAndReferralList } from "../RecordNoteAndReferralList";
import { RecordNoteList } from "../RecordNoteList";

export const Journal: React.FC = () => {
  const { hasFeature } = useFeatureToggleContext();
  const patientId = Number(useParams().patientId);
  const { profile } = useProfileContext();
  const isPhysician = userIsPhysician(profile);

  return (
    <Container data-testid="journal">
      {!isPhysician && (hasFeature(Feature.REFERRALS) ? <RecordNoteAndReferralList /> : <RecordNoteList />)}
      {isPhysician && <PhysicianList patientId={patientId} />}
    </Container>
  );
};

export const Container = styled(Box)({
  maxWidth: 810,
  width: "100%",
  margin: "0 auto",
  boxSizing: "border-box",
});
